import React from 'react'
import { Flex, Loader } from '@sendoutcards/quantum-design-ui'
import { useMeasurements, useSelector } from 'src/hooks'

export const ApplicationSettingsLoader = () => {
  const { windowWidth } = useMeasurements()
  const isScreenTooSmall = windowWidth < 960
  const isMobile = useSelector(state => state.window.width <= 474)

  if (isScreenTooSmall) {
    // Mobile layout - vertical stacking
    return (
      <Flex flexDirection="column" alignItems="stretch" inset="x4">
        {/* Title skeleton */}
        <Loader width={200} height={32}>
          <rect x={0} y={0} width={200} height={32} rx={4} ry={4} />
        </Loader>

        {/* Typeface label skeleton */}
        <Flex inset={{ top: 'x3' }}>
          <Loader width={60} height={14}>
            <rect x={0} y={0} width={60} height={14} rx={2} ry={2} />
          </Loader>
        </Flex>

        {/* Typeface dropdown skeleton */}
        <Flex inset={{ top: 'x1' }}>
          <Loader width={isMobile ? 280 : 320} height={48}>
            <rect
              x={0}
              y={0}
              width={isMobile ? 280 : 320}
              height={48}
              rx={8}
              ry={8}
            />
          </Loader>
        </Flex>

        {/* Text Size label skeleton */}
        <Flex inset={{ top: 'x3' }}>
          <Loader width={70} height={14}>
            <rect x={0} y={0} width={70} height={14} rx={2} ry={2} />
          </Loader>
        </Flex>

        {/* Text size options skeleton */}
        <Flex inset={{ top: 'x1' }}>
          <Loader width={isMobile ? 280 : 320} height={48}>
            <rect x={0} y={0} width={48} height={48} rx={8} ry={8} />
            <rect x={56} y={0} width={48} height={48} rx={8} ry={8} />
            <rect x={112} y={0} width={48} height={48} rx={8} ry={8} />
            <rect x={168} y={0} width={48} height={48} rx={8} ry={8} />
            {!isMobile && (
              <>
                <rect x={240} y={12} width={24} height={24} rx={2} ry={2} />
                <rect x={272} y={16} width={32} height={16} rx={2} ry={2} />
              </>
            )}
          </Loader>
        </Flex>

        {/* Color label skeleton */}
        <Flex inset={{ top: 'x3' }}>
          <Loader width={40} height={14}>
            <rect x={0} y={0} width={40} height={14} rx={2} ry={2} />
          </Loader>
        </Flex>

        {/* Color options skeleton */}
        <Flex inset={{ top: 'x1' }}>
          <Loader width={isMobile ? 280 : 320} height={40}>
            <circle cx={20} cy={20} r={20} />
            <circle cx={68} cy={20} r={20} />
            <circle cx={116} cy={20} r={20} />
            <circle cx={164} cy={20} r={20} />
            <circle cx={212} cy={20} r={20} />
            {!isMobile && (
              <rect x={260} y={12} width={60} height={16} rx={4} ry={4} />
            )}
          </Loader>
        </Flex>
      </Flex>
    )
  }

  // Desktop layout - same as mobile but with full width
  return (
    <Flex
      flexDirection="column"
      alignItems="stretch"
      inset={{
        horizontal: 'x4',
        vertical: 'x3',
      }}
    >
      {/* Title skeleton */}
      <Loader width={220} height={32}>
        <rect x={0} y={0} width={220} height={32} rx={4} ry={4} />
      </Loader>

      {/* Typeface label skeleton */}
      <Flex inset={{ top: 'x3' }}>
        <Loader width={60} height={14}>
          <rect x={0} y={0} width={60} height={14} rx={2} ry={2} />
        </Loader>
      </Flex>

      {/* Typeface dropdown skeleton */}
      <Flex inset={{ top: 'x1' }}>
        <Loader width={400} height={48}>
          <rect x={0} y={0} width={400} height={48} rx={8} ry={8} />
        </Loader>
      </Flex>

      {/* Text Size label skeleton */}
      <Flex inset={{ top: 'x3' }}>
        <Loader width={70} height={14}>
          <rect x={0} y={0} width={70} height={14} rx={2} ry={2} />
        </Loader>
      </Flex>

      {/* Text size options skeleton */}
      <Flex inset={{ top: 'x1' }}>
        <Loader width={500} height={48}>
          <rect x={0} y={0} width={48} height={48} rx={8} ry={8} />
          <rect x={56} y={0} width={48} height={48} rx={8} ry={8} />
          <rect x={112} y={0} width={48} height={48} rx={8} ry={8} />
          <rect x={168} y={0} width={48} height={48} rx={8} ry={8} />
          <rect x={260} y={12} width={28} height={28} rx={2} ry={2} />
          <rect x={296} y={16} width={36} height={20} rx={2} ry={2} />
          <rect x={340} y={20} width={12} height={12} rx={2} ry={2} />
          <rect x={360} y={16} width={50} height={20} rx={2} ry={2} />
        </Loader>
      </Flex>

      {/* Color label skeleton */}
      <Flex inset={{ top: 'x3' }}>
        <Loader width={40} height={14}>
          <rect x={0} y={0} width={40} height={14} rx={2} ry={2} />
        </Loader>
      </Flex>

      {/* Color options skeleton */}
      <Flex inset={{ top: 'x1' }}>
        <Loader width={500} height={40}>
          <circle cx={20} cy={20} r={20} />
          <circle cx={68} cy={20} r={20} />
          <circle cx={116} cy={20} r={20} />
          <circle cx={164} cy={20} r={20} />
          <circle cx={212} cy={20} r={20} />
          <rect x={400} y={12} width={80} height={16} rx={4} ry={4} />
        </Loader>
      </Flex>
    </Flex>
  )
}
